import {HTTP} from '../../common/http';

import {
    FETCH_USERS,
    FETCH_IDENTITY_TOKEN,
} from './mutation-types';

const localDomain = window.greenmotion.portalEndpoint || '';

export function fetchUsers({commit}, {email}) {
    return HTTP.get(`${localDomain}users`, {
        params: {
            email
        }
    })
    .then((response) => commit(FETCH_USERS, response.data.data));
};

export function fetchIdentityToken({ commit, state }, fresh) {
    return HTTP.get(`${localDomain}identity`, {
        params: {
            fresh
        }
    }).then((response) => commit(FETCH_IDENTITY_TOKEN, response.data.data));
};


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/users/actions.js